import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import useAxios from "axios-hooks";
import { API_ROUTES } from "utils/constant";
import { ROOT_API } from "utils/constant";
import SelectController from "components/Form/SelectController";

const defaultValues = {
  brandFrom: undefined,
};

const SyncEmailModal = ({ isOpen, onClose, currentBrand }) => {
  const cancelRef = React.useRef();
  const toast = useToast();

  const [emailResult, setEmailResult] = useState(null);

  const [{ data: branchData, loading, error }, refetch] = useAxios({
    url: ROOT_API + API_ROUTES.SMTP_SERVER,
  });

  const [{ loading: syncLoading }, syncEmailApi] = useAxios(
    {
      url: ROOT_API + API_ROUTES.SYNC_EMAIL,
      method: "post",
    },
    { manual: true }
  );

  const branchOptions = useMemo(
    () =>
      branchData?.data
        ?.filter((item) => item.brand !== currentBrand)
        ?.map((item) => ({
          label: item.brand,
          value: item.brand,
        })),
    [branchData?.data]
  );

  const schema = yup.object().shape({
    brandFrom: yup.object().required("Vui lòng chọn brand"),
  });
  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  useEffect(
    () => () => {
      reset();
      setEmailResult(null);
    },
    []
  );

  const onSubmit = (values) => {
    toast.closeAll();

    const dataPayload = {
      brandFrom: values?.brandFrom?.value,
      brandTo: currentBrand,
    };

    syncEmailApi({
      data: {
        ...dataPayload,
      },
    })
      .then((res) => {
        toast({
          title: "Sync emails Backup Successfully",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        refetch();
        reset();
        onClose();
      })
      .catch((error) => {
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Sync emails Backup Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      });
  };

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          reset();
          onClose?.();
          setEmailResult(null);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Sync email to {currentBrand}</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <form>
              <SelectController
                control={control}
                name="brandFrom"
                label="From Branch"
                options={branchOptions}
              />
            </form>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                reset();
                onClose?.();
                setEmailResult(null);
              }}
            >
              Cancel
            </Button>
            {!emailResult && (
              <Button
                colorScheme="blue"
                ml={3}
                isLoading={syncLoading}
                onClick={handleSubmit(onSubmit)}
              >
                Sync
              </Button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default SyncEmailModal;
